// extracted by mini-css-extract-plugin
module.exports = {"selectorWrp":"styles_selectorWrp__3WpUx","loaderWrp":"styles_loaderWrp__2mybK"};